import { Button } from "PFComponents/button";
import useIsFeatureEnabled from "PFCore/helpers/use_is_feature_enabled";
import { FeatureFlag, Id } from "PFTypes";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { ApplyEngagementBlueprintModal } from "./apply_engagement_blueprint_modal";

type ApplyEngagementBlueprintButtonProps = {
  activityId: Id;
};

export const ApplyEngagementBlueprintButton = ({ activityId }: ApplyEngagementBlueprintButtonProps) => {
  const { t } = useTranslation("activities", { keyPrefix: "engagementBlueprint" });
  const isEnabled = useIsFeatureEnabled();
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (!isEnabled(FeatureFlag.EngagementBlueprints)) {
    return null;
  }

  return (
    <>
      <Button kind="secondary" text={t("applyEngagementBlueprint")} onClick={() => setIsModalOpen(true)} />
      {isModalOpen && (
        <ApplyEngagementBlueprintModal onClose={() => setIsModalOpen(false)} activityId={activityId} />
      )}
    </>
  );
};
